import { TabTile } from './TabTile'
// import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  wrapHeader: {
    display: 'flex',
    width: '100%',
    maxWidth: 'calc(100% - 32px)',
    overflow: 'hidden',
  },
  wrapNameAndPhrases: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  description: {
    fontFamily: 'Lato',
    fontSize: 12,
    color: theme.defaults.textGray,
    marginBottom: 0,
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  name: {
    fontFamily: 'Lato',
    fontSize: 18,
    marginBottom: 0,
    color: theme.defaults.textHeader,
  },
  flowExp: {
    display: 'inline-block',
    width: '100%',
    maxWidth: '100%',
    borderRadius: '10px !important',
    overflow: 'hidden',
    margin: '16px 0 0 !important',
    boxShadow: ' 4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    '& >div': {
      width: '100%',
      padding: '0 40px',
    },
  },
  mainWrap: {
    maxWidth: '100%',
    display: 'inline-block',
    borderRadius: 10,
    height: 'auto',
    justifyContent: 'space-between',
    '& [class*="MuiIconButton"]': {
      right: 24,
    },
    '& [class*="MuiExpansionPanel"]:not([class*="MuiIconButton"])': {
      margin: '24px 0',
    },
    "& [class*='MuiExpansionPanel']:before ": {
      display: 'none',
    },
    '::before': {
      display: 'none',
    },
  },
})

// @ts-ignore
export default withStyles(styles, { withTheme: true })(TabTile)
